import { fsUpdateDoc } from '@monash/portal-frontend-common';

export const updateLastViewedInFirestore = (currentUser) => {
  const id = currentUser.uid;
  const path = `users/${id}`;
  fsUpdateDoc(path, {
    'preferences.lastViewedUpdatesPage': Date.now(),
  });
};
